import { generateRandomString } from '@mntn-dev/utilities'
import { z } from 'zod'

export const MntnCustomerIdSchema = z.string().brand('mntn-customer-id')

export type MntnCustomerId = z.infer<typeof MntnCustomerIdSchema>

export const MntnCustomerId = (
  value: string = generateRandomString()
): MntnCustomerId => {
  return MntnCustomerIdSchema.parse(value)
}
